export default __webpack_public_path__ + "static/media/modalClose.1aee328e.svg";